import {api} from '../api';
import {saveAs} from 'file-saver';
import {MimeTypes} from "../../constants/mimeTypes";

const FilesRequest = (
  init: FormData,
  files: Record<string, File | File[] | null>
) => {
  for (const [key, value] of Object.entries(files)) {
    if (value == null) continue;
    if (value instanceof Blob) {
      init.append(key, value);
      continue;
    }
    for (let index = 0; index < value.length; index++) {
      const file = value[index];
      if (file) init.append(`${key}`, file);
    }
  }
};

export const customApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    listener: builder.query({
      query: ({path, body, method = 'GET', cache = 'default'}) => ({
        url: `${path}`,
        method,
        body,
        cache,
      }),
      providesTags: (result, error, arg) =>
        !!result || !!arg
          ? arg.tags
            ? arg.tags
            : [arg.path.split('/')[0]]
          : [],
    }),
    speaker: builder.mutation({
      query: ({path, body, method = 'POST', cache = 'default'}) => ({
        url: `${path}`,
        method,
        body,
        cache,
      }),
      invalidatesTags: (result, error, arg) =>
        !!result || !!arg
          ? arg.tags
            ? arg.tags
            : [arg.path.split('/')[0]]
          : [],
    }),
    getRequest: builder.query({
      query: ({path}) => ({
        url: `${path}`,
        method: 'GET',
        keepUnusedDataFor: 1,
      }),
      providesTags: (result, error, arg) =>
        !!result || !!arg
          ? arg.tags
            ? arg.tags
            : [arg.path.split('/')[0]]
          : [],
    }),
    deleteRequest: builder.mutation({
      query: ({path, body}) => ({
        url: `${path}`,
        method: 'DELETE',
        body,
      }),
      invalidatesTags: (result, error, arg) =>
        !!result || !!arg
          ? arg.tags
            ? arg.tags
            : [arg.path.split('/')[0]]
          : [],
    }),
    requestWithFormData: builder.mutation({
      query: ({
                path,
                body,
                requestPartName = 'request',
                method = 'POST',
                ...rest
              }) => {
        const {attachments = undefined,files, ...otherBody} = body;
        const newBody = new FormData();
        if (otherBody) {
          newBody.append(
            requestPartName,
            new Blob([JSON.stringify(otherBody)], {type: 'application/json'})
          );
        }
        if(files){
          FilesRequest(newBody, files);
        }
        if (attachments !== undefined) {
          FilesRequest(newBody, {attachments: attachments});
        }
        return {
          url: `${path}`,
          method: method,
          body: newBody,
          ...rest,
        };
      },
      invalidatesTags: (result, error, arg) =>
        result ? (arg.tags ? arg.tags : [arg.path.split('/')[0]]) : [],
    }),
    getFile: builder.query({
      query: ({path, body, type, method = 'GET'}) => ({
        url: `${path}`,
        body,
        method,
        responseHandler: async (response) => {
          const blob: Blob = await response.blob();
          const stream = new Blob([blob], {
            type: type
              ? MimeTypes[type[0]]
              : response.headers.get('content-type') ?? undefined,
          });
          return URL.createObjectURL(stream);
        },
      }),
    }),
    downloadFile: builder.query({
      query: ({path, name, body, method = 'GET'}) => ({
        url: path,
        method,
        body,
        responseHandler: async (response) => {
          if (response.status !== 200) {
            throw new Error('Ошибка при скачивании файла');
          } else {
            saveAs(await response.blob(), name);
          }
        },
      }),
    }),
    searchRequest: builder.query({
      query: ({
                path,
                body,
                cache = 'no-cache',
              }: {
        path: string;
        body: Record<string, unknown>;
        cache?: RequestCache;
        tags?: any;
      }) => ({
        url: path,
        method: 'POST',
        body,
        cache: cache,
      }),
      providesTags: (result, error, arg) =>
        !!result || !!arg
          ? arg.tags
            ? arg.tags
            : [arg.path.split('/')[0]]
          : [],
    }),
  }),
  overrideExisting: true,
});

export const {
  useLazyListenerQuery,
  useListenerQuery,
  useSpeakerMutation,
  useDeleteRequestMutation,
  useRequestWithFormDataMutation,
  useLazyGetFileQuery,
  useLazyDownloadFileQuery,
  useLazySearchRequestQuery,
  useSearchRequestQuery,
} = customApiSlice;
